/* eslint-disable  */
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Button, Chip, Grid, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import { Add, Delete } from '@material-ui/icons';
import Theme from '../ui/Theme';
import PopupText from '../common/PopupText';
import PopupTextField from '../common/PopupTextField';
import { getRulesDetails, setRulesListData, showProgress } from '../../redux/actions/DealershipActions';
import MultiSelectSearch from '../common/search/MultiSelectSearch';
import service from '../../apis/service';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';

const customStyles = {
  content: {
    height: '70%',
    width: '70%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '15px',
  },
};
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
    marginRight: '28px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  content: {
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  cardContent: {
    marginRight: '10px',
    marginTop: '10px',
    marginBottom: '10px',
    border: 0,
    backgroundColor: '#F2F4F7',
    position: 'relative',
  },
  orCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
  },
  chipOrCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '13px',
    lineHeight: '13px',
    color: 'black',
  },
  andCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  orButton: {
    width: '50px',
    height: '23px',
    radius: '2px',
    padding: '4px, 8px, 4px, 8px',
    gap: '4px',
    color: '#622FEE',
    border: '1px solid #622FEE;',
    borderRadius: '2px',
    fontSize: '15px',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    lineHeight: '15px',
  },
  andButton: {
    width: '44px',
    height: '15px',
    borderRadius: '2px',
    gap: '4px',
    color: '#622FEE',
    fontSize: '15px',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    lineHeight: '15px',
    position: 'absolute',
    bottom: 0,
    right: 0,
    margin: '10px',
    marginRight: '50px',
  },
  deleteButton: {
    color: 'red',
    cursor: 'pointer',
    position: 'absolute',
    bottom: 0,
    right: 0,
    marginBottom: '5px',
    marginRight: '10px',
  },
  chipStyle: {
    backgroundColor: '#F2F4F7',
    margin: '2px',
    padding: 0,
  },
  multiSearch: {
    marginTop: '5px',
    marginBottom: '5px',
    marginLeft: '5px',
  },
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '250px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  scrollContent: {
    marginTop: '17px',
    marginLeft: '3px',
    width: '100%',
    maxHeight: '40vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
}));

const RuleAddNewPopup = ({ close, add, selectedData, refreshData, handleListItemClick }) => {
  const classes = useStyles();
  const [data, setData] = useState({});
  const [conditionsList, setConditionsList] = useState([{ condition: [[]] }]);
  const [customGroupsList, setCustomGroupsList] = useState([]);
  const dispatch = useDispatch();

  const transformResponse = (conditions) => {
    const temp = JSON.parse(JSON.stringify(conditions || []));
    for (let i = 0; i < temp.length; i += 1) {
      for (let j = 0; j < temp[i].condition.length; j += 1) {
        for (let k = 0; k < temp[i].condition[j].length; k += 1) {
          temp[i].condition[j][k] = {
            value: temp[i].condition[j][k].id,
            label: temp[i].condition[j][k].name,
          };
        }
      }
    }
    return temp;
  };

  useEffect(() => {
    if (!add) {
      setData({
        id: selectedData.id,
        name: selectedData.name,
      });
      setConditionsList(transformResponse(selectedData.conditions));
    }
  }, [add, selectedData]);

  useEffect(() => {
    const fetchCustomGroupsData = async () => {
      dispatch(showProgress(true));
      await service
        .get(apiEndpoints.CG_LIST)
        .then((response) => {
          setCustomGroupsList(response?.map((r) => ({ value: r.id, label: r.name })) || []);
          dispatch(showProgress(false));
        })
        .catch((error) => {
          ErrorToast(error);
          dispatch(showProgress(false));
        });
    };
    fetchCustomGroupsData();
  }, [dispatch]);

  const handleDataChange = ({ target }) => {
    setData({ ...data, [target.name]: target.value });
  };

  const handleOrConditonClick = () => {
    setConditionsList((val) => [
      ...val,
      {
        condition: [[]],
      },
    ]);
  };

  const handleAndConditionClick = (index) => {
    const tempArr = JSON.parse(JSON.stringify(conditionsList || []));
    tempArr[index].condition.push([]);
    setConditionsList(tempArr);
  };

  const saveInput = (val, i, j) => {
    const temp = JSON.parse(JSON.stringify(conditionsList || []));
    temp[i].condition[j] = val;
    // if (temp[i].id) delete temp[i].id;
    setConditionsList(temp);
  };

  const handleDelete = (i) => {
    const temp = JSON.parse(JSON.stringify(conditionsList || []));
    // if (temp[i].id) delete temp[i].id;
    if (i === 0 && temp[i].condition.length > 1) {
      temp[i].condition.pop();
      setConditionsList(temp);
    } else if (i !== 0) {
      temp[i].condition.pop();
      if (!temp[i].condition.length) {
        temp.splice(i, 1);
        setConditionsList(temp);
      } else {
        setConditionsList(temp);
      }
    }
  };

  const transformRequest = (conditions = [], isCreate = false) => {
    const temp = JSON.parse(JSON.stringify(conditions || []));
    for (let i = 0; i < temp.length; i += 1) {
      for (let j = 0; j < temp[i].condition.length; j += 1) {
        for (let k = 0; k < temp[i].condition[j].length; k += 1) {
          temp[i].condition[j][k] = temp[i].condition[j][k].value;
        }
        temp[i].condition[j] = temp[i].condition[j].filter((z) => z !== '*');
      }
    }
    if (isCreate) return temp.map((i) => i.condition);
    return temp;
  };

  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!data.name) {
      formIsValid = false;
      errors.push('Please enter name of rule.');
    }
    if (!conditionsList.length || !conditionsList[0].condition.length || !conditionsList[0].condition[0].length) {
      formIsValid = false;
      errors.push('Please add atleast one condition.');
    }
    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };

  const fetchDataAfterUpdate = async () => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.RULES_FETCH)
      .then((response) => {
        dispatch(setRulesListData(response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  const saveRule = async () => {
    const check = validateForm();
    const { name } = data;
    if (check) {
      dispatch(showProgress(true));
      const request = {
        name,
        conditions: transformRequest(conditionsList, add),
      };
      if (add) {
        await service
          .post(apiEndpoints.RULES_CREATE, request)
          .then((response) => {
            handleListItemClick(response.id);
            refreshData();
            dispatch(showProgress(false));
            notifySuccess('Saved Successfully');
            close();
          })
          .catch((error) => {
            dispatch(showProgress(false));
            ErrorToast(error);
          });
      } else {
        await service
          .put(apiEndpoints.RULES_UPDATE.replace('ID', data.id), request)
          .then(async () => {
            dispatch(showProgress(false));
            await fetchDataAfterUpdate();
            dispatch(getRulesDetails(data.id));
            notifySuccess('Saved Successfully');
            close();
          })
          .catch((error) => {
            dispatch(showProgress(false));
            ErrorToast(error);
          });
      }
    }
  };

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (!value.length) return placeholderButtonLabel;

    const containsAll = value.some((i) => i.value === '*');
    const index = containsAll ? 2 : 1;
    return (
      <Grid container>
        {value
          .filter((i) => i.value !== '*')
          .map((i, j) => (
            <div style={{ height: 'auto' }} key={i.value}>
              {' '}
              <Chip className={classes.chipStyle} label={i.label} />{' '}
              {j < value.length - index ? <span className={classes.chipOrCondition}>OR</span> : null}{' '}
            </div>
          ))}
      </Grid>
    );
  }

  return (
    <Modal isOpen onRequestClose={close} style={customStyles}>
      <Grid container direction="row" alignItems="center">
        <Grid item xs={11}>
          <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
            <Grid item className={classes.popupHeading}>
              {add ? 'Add Rule' : 'Edit Rule'}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          <CloseIcon className={classes.popupCloseBtn} onClick={close} />
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={12} className={classes.content}>
          <Grid container direction="column">
            <Grid item>
              <PopupText text="Rule Name" required />
            </Grid>
            <Grid item>
              <PopupTextField
                name="name"
                placeholder="Rule Name"
                id="name_id"
                height="44"
                handleChange={handleDataChange}
                value={data.name}
                width="100%"
              />
            </Grid>
            <Grid item>
              <PopupText text="Conditions" required />
            </Grid>
            <Grid item className={classes.scrollContent}>
              {conditionsList.map((orC, orIndex) => (
                <div key={orIndex}>
                  <div className={classes.cardContent} raised={false} variant="outlined">
                    <Grid container justifyContent="space-around" alignContent="center" alignItems="center">
                      {orC.condition.map((i, j) => (
                        <Grid
                          item
                          xs={5}
                          className={classes.multiSearch}
                          key={j}
                          style={{ marginTop: '10px', marginBottom: '10px' }}
                        >
                          <MultiSelectSearch
                            placeholderButtonLabel="Select Custom groups"
                            selectedOptions={conditionsList[orIndex].condition[j]}
                            onChange={(val) => saveInput(val, orIndex, j)}
                            options={customGroupsList}
                            name="customGroups"
                            showValue
                            maxMenuHeight={190}
                            labelWidth="250px"
                            width="350px"
                            // eslint-disable-next-line react/jsx-no-bind
                            getDropdownButtonLabel={getDropdownButtonLabel}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                backgroundColor: 'white',
                              }),
                              dropdownButton: (baseProvided) => ({
                                ...baseProvided,
                                background: 'white',
                                border: 'none',
                              }),
                            }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                    <div style={{ textAlign: 'center', justifyContent: 'center' }}>
                      <Button
                        className={classes.andButton}
                        variant="text"
                        onClick={() => handleAndConditionClick(orIndex)}
                      >
                        {' '}
                        <Add /> AND
                      </Button>
                      <Delete className={classes.deleteButton} onClick={() => handleDelete(orIndex)} />
                    </div>
                  </div>
                  <Grid container justifyContent="center">
                    <Grid item md={5}>
                      <hr />
                    </Grid>
                    <Grid item md={1} className={classes.orCondition}>
                      {orIndex === conditionsList.length - 1 ? (
                        <Button className={classes.orButton} variant="outlined" onClick={handleOrConditonClick}>
                          {' '}
                          <Add /> OR
                        </Button>
                      ) : (
                        'OR'
                      )}
                    </Grid>
                    <Grid item md={5}>
                      <hr />
                    </Grid>
                  </Grid>
                </div>
              ))}
              <div style={{ height: '300px' }}></div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" alignItems="center" style={{ marginTop: '30px' }}>
        <Button variant="contained" className={classes.popCancelBtn} onClick={close}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" className={classes.popSubmitBtn} onClick={saveRule}>
          Save
        </Button>
      </Grid>
    </Modal>
  );
};

export default RuleAddNewPopup;
